import { useParams } from "@tanstack/react-router";
import { AnalyticsCatalogContext, catalogSeoQualityTier } from "@/components/analytics-catalog-context";
import { CompanyContent } from "./$id/company-content";
interface CompanySearch {
  q?: string;
  type?: string;
  sort?: string;
  format?: string;
  genre?: string[];
  style?: string[];
  country?: string;
  label?: string[];
  company?: string[];
  year?: number[];
  filter?: ReleaseSearchFilter;
}
import { Route } from "/app/apps/web/src/routes/_app/company/$id.tsx";
function CompanyRoute() {
  const {
    id
  } = useParams({
    from: "/_app/company/$id"
  });
  const loaderData = Route.useLoaderData();
  return <>
      <AnalyticsCatalogContext entityType="company" qualityTier={catalogSeoQualityTier(loaderData.company)} />
      <CompanyContent id={id} discographyQueryType={loaderData.discographyQueryType} discographyTypeCounts={loaderData.discographyTypeCounts} />
    </>;
}
export { CompanyRoute as component };